/* eslint-disable no-unsafe-optional-chaining */
import {
  Autocomplete,
  CircularProgress,
  createFilterOptions,
  FormHelperText,
  Grid,
} from "@mui/material";
import Counter from "components/Counter";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { FieldArray } from "formik";
import React from "react";
import { DeleteOutline, Add } from "@mui/icons-material";

const kpiFilter = createFilterOptions();

function Criteria({ formData, kpiActivities, winConditions, winConditionLoading }) {
  const { values, errors, touched, setFieldValue } = formData;
  const {
    winCondition: winConditionV,
    target: targetV,
    kpiActivities: activities,
  } = values.criteria;

  return (
    <MDBox>
      <Grid container spacing={3} p={1}>
        <Grid item xs={12} sm={3}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <MDBox>
                <MDTypography variant="h5" fontWeight="bold">
                  Criteria
                </MDTypography>
                <MDTypography variant="subtitle2" sx={{ color: "#7b809a" }}>
                  What is the win condition?
                </MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                fullWidth
                id="criteria"
                disableClearable
                options={winConditions}
                onChange={(_, value) => {
                  setFieldValue("criteria.winCondition", value);
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option?.condition || ""}
                value={winConditionV}
                renderInput={(params) => (
                  <MDInput
                    {...params}
                    variant="standard"
                    placeholder="Criteria"
                    label="Criteria"
                    error={
                      touched?.criteria?.winCondition && Boolean(errors?.criteria?.winCondition)
                    }
                    helperText={touched?.criteria?.winCondition && errors?.criteria?.winCondition}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {winConditionLoading ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
              {touched?.criteria?.winCondition && errors?.criteria?.winCondition ? (
                <FormHelperText>{errors.criteria.winCondition}</FormHelperText>
              ) : null}
            </Grid>
            {winConditions?.find((condition) => condition?.condition === winConditionV?.condition)
              ?.condition === "First To KPI Target" && (
              <Grid item xs={12}>
                <MDInput
                  variant="standard"
                  fullWidth
                  type="number"
                  id="target"
                  value={targetV}
                  placeholder="KPI Target"
                  label="KPI Target"
                  onChange={(event) => {
                    setFieldValue(
                      "criteria.target",
                      event.target.value ? parseInt(event.target.value, 10) : ""
                    );
                  }}
                  error={touched?.criteria?.target && Boolean(errors?.criteria?.target)}
                  helperText={touched?.criteria?.target && errors?.criteria?.target}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} sm={9} mt={1}>
          <FieldArray name="criteria.kpiActivities">
            {({ push, remove }) => (
              <>
                <Grid container spacing={2}>
                  {activities?.map((kpiActivity, i) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <React.Fragment key={i}>
                      <Grid
                        item
                        xs={11}
                        sm={11}
                        md={
                          winConditions?.find(
                            (condition) => condition?.condition === winConditionV?.condition
                          )?.condition === "Total Points"
                            ? 7.5
                            : 11.5
                        }
                      >
                        <Autocomplete
                          value={activities?.[i]}
                          onChange={(event, newValue) => {
                            setFieldValue(`criteria.kpiActivities[${i}]`, {
                              id: newValue?.id || null,
                              name: newValue?.inputValue || newValue?.name || "",
                              count: kpiActivity.count,
                              points: kpiActivity.points,
                            });
                          }}
                          onBlur={(blurEvent) => {
                            if (!blurEvent?.target?.value?.trim()) return;
                            const foundKpi = kpiActivities.find(
                              (kpi) => kpi?.name === blurEvent?.target?.value
                            );

                            // if (
                            //   activities.find(
                            //     (activity) => activity.name === blurEvent?.target?.value
                            //   )
                            // ) {
                            //   setFieldValue(`criteria.kpiActivities[${i}]`, {
                            //     id: null,
                            //     name: "",
                            //     count: kpiActivity.count,
                            //     points: kpiActivity.points,
                            //   });
                            //   return;
                            // }

                            if (foundKpi) {
                              setFieldValue(`criteria.kpiActivities[${i}]`, {
                                id: foundKpi?.id || null,
                                name: foundKpi?.inputValue || foundKpi?.name || "",
                                count: kpiActivity.count,
                                points: kpiActivity.points,
                              });
                            } else {
                              setFieldValue(`criteria.kpiActivities[${i}]`, {
                                id: null,
                                name: blurEvent.target.value || "",
                                count: kpiActivity.count,
                                points: kpiActivity.points,
                              });
                            }
                          }}
                          filterOptions={(options, params) => {
                            const filtered = kpiFilter(
                              kpiActivities.filter(
                                (_) => !activities.find((act) => act.name === _.name)
                              ),
                              params
                            );
                            // const { inputValue } = params;
                            // // Suggest the creation of a new value
                            // const isExisting = options.some(
                            //   (option) => inputValue === option?.name
                            // );
                            // if (inputValue !== "" && !isExisting) {
                            //   filtered.push({
                            //     inputValue,
                            //     name: `Add "${inputValue}"`,
                            //   });
                            // }

                            return filtered;
                          }}
                          selectOnFocus
                          handleHomeEndKeys
                          id="free-solo-with-text-demo"
                          options={kpiActivities}
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                          getOptionLabel={(option) => {
                            if (option?.name) {
                              return option?.name;
                            }
                            return "";
                          }}
                          // eslint-disable-next-line react/jsx-props-no-spreading
                          renderOption={(props, option) => <li {...props}>{option?.name || ""}</li>}
                          freeSolo
                          fullWidth
                          renderInput={(params) => (
                            <MDInput
                              error={
                                !!errors?.criteria?.kpiActivities?.[i]?.name &&
                                touched?.criteria?.kpiActivities?.[i]?.name
                              }
                              helperText={
                                touched?.criteria?.kpiActivities?.[i]?.name &&
                                errors?.criteria?.kpiActivities?.[i]?.name
                              }
                              {...params}
                              label="Select Kpi"
                              variant="standard"
                            />
                          )}
                        />
                        {touched?.criteria?.kpiActivities?.[i]?.name &&
                        errors?.criteria?.kpiActivities?.[i]?.name ? (
                          <FormHelperText>{errors.criteria.kpiActivities[i].name}</FormHelperText>
                        ) : null}
                      </Grid>
                      {winConditions?.find(
                        (condition) => condition?.condition === winConditionV?.condition
                      )?.condition === "Total Points" && (
                        <Grid item xs={5} md={2}>
                          <Counter
                            label="Count"
                            helperText={errors?.criteria?.kpiActivities?.[i]?.count}
                            counter={kpiActivity.count}
                            handleChange={(e) => {
                              setFieldValue(
                                `criteria.kpiActivities[${i}].count`,
                                parseInt(e.target.value || 1, 10)
                              );
                            }}
                            increment={() => {
                              if (kpiActivity.count <= 999) {
                                setFieldValue(
                                  `criteria.kpiActivities[${i}].count`,
                                  kpiActivity?.count + 1
                                );
                              }
                            }}
                            decrement={() => {
                              if (kpiActivity.count > 1) {
                                setFieldValue(
                                  `criteria.kpiActivities[${i}].count`,
                                  kpiActivity?.count - 1
                                );
                              }
                            }}
                            variant="standard"
                          />
                        </Grid>
                      )}
                      {winConditions?.find(
                        (condition) => condition?.condition === winConditionV?.condition
                      )?.condition === "Total Points" && (
                        <Grid item xs={5} md={2}>
                          <Counter
                            label="Points"
                            helperText={
                              touched?.criteria?.kpiActivities?.[i]?.points &&
                              Boolean(errors?.criteria?.kpiActivities?.[i]?.points) &&
                              errors?.criteria?.kpiActivities?.[i]?.points
                            }
                            counter={kpiActivity.points}
                            increment={() => {
                              if (kpiActivity.points < 999) {
                                setFieldValue(
                                  `criteria.kpiActivities[${i}].points`,
                                  kpiActivity?.points + 1
                                );
                              }
                            }}
                            handleChange={(e) => {
                              setFieldValue(
                                `criteria.kpiActivities[${i}].points`,
                                parseInt(e.target.value || 1, 10)
                              );
                            }}
                            decrement={() => {
                              if (kpiActivity.points > 1) {
                                setFieldValue(
                                  `criteria.kpiActivities[${i}].points`,
                                  kpiActivity?.points - 1
                                );
                              }
                            }}
                            variant="standard"
                          />
                        </Grid>
                      )}
                      {activities.length !== 1 && (
                        <Grid
                          item
                          xs={0.5}
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          marginTop="10px"
                        >
                          <DeleteOutline
                            sx={{ cursor: "pointer" }}
                            color="error"
                            onClick={() => remove(i)}
                          />
                        </Grid>
                      )}
                      {activities.length - 1 === i &&
                        typeof errors?.criteria?.kpiActivities === "string" && (
                          <FormHelperText sx={{ margin: "1rem 1rem" }}>
                            {errors?.criteria?.kpiActivities}
                          </FormHelperText>
                        )}
                    </React.Fragment>
                  ))}
                </Grid>
                <MDBox sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                  <MDButton
                    variant="outlined"
                    color="newColor"
                    type="button"
                    typeof="button"
                    onClick={() => push({ id: null, count: 1, name: "", points: 1 })}
                  >
                    <Add
                      sx={{
                        "&.MuiSvgIcon-root ": { mr: 0.8, mb: 0.5, fontSize: "1rem !important" },
                      }}
                    />{" "}
                    Add new
                  </MDButton>
                </MDBox>
              </>
            )}
          </FieldArray>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default Criteria;
